import { apiPrefixes } from '@/api/apiPrefixes'
import { http } from '@/utils'

const api = {
  queryDistricts: `${apiPrefixes.addressapi}/addressview/GetDistrictList`
}

export async function queryDistricts(cityId: number | string) {
  try {
    const result: any = await http.get(`${api.queryDistricts}?cityId=${cityId}`)
    const { DistrictList } = result
    return DistrictList || []
  } catch (e) {
    return []
  }
}
